
namespace TabAurous.Reports {

    @Serenity.Decorators.registerClass()
    export class ItemsRegisterGrid extends Serenity.EntityGrid<ItemsRegisterRow, any> {
        protected getColumnsKey() { return 'Reports.ItemsRegister'; } 
        protected getIdProperty() { return ItemsRegisterRow.idProperty; }
        protected getInsertPermission() { return ItemsRegisterRow.insertPermission; }
        protected getLocalTextPrefix() { return ItemsRegisterRow.localTextPrefix; }
        protected getService() { return ItemsRegisterService.baseUrl; }
        public vouchertypeid: number;
        constructor(container: JQuery) {
            super(container);

            this.setTitle("");
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass == "");
            buttons.push({
                title: 'Filters',
                cssClass: 'send-button',
                icon: 'fa-filter',
                onClick: () => {
                    var dialog = new Common.ItemsRegisterFiltersDialog;
                    dialog.filterformfor = "Transaction";
                    dialog.form.ItemsOnly.value = true;
                    dialog.dialogOpen();
                    dialog.element.on('dialogclose', () => {
                        //this.refresh();
                        if (dialog.checksuccess) {
                            (this.view.params as ReportFiltersRequest).VoucherTypeId = dialog.vouchertypeid;
                            this.vouchertypeid = dialog.vouchertypeid;
                            var vouchernos = dialog.vouchernos;
                            var partyids = dialog.partyids;
                            (this.view.params as ReportFiltersRequest).PartyIds = partyids;
                            (this.view.params as ReportFiltersRequest).VoucherNos = vouchernos ;
                            //this.onViewSubmit();
                            this.view.refresh();
                            ItemsRegisterService.List({ VoucherTypeId: dialog.vouchertypeid, VoucherNos: vouchernos, PartyIds:partyids }, response => { this.view.setItems(response.Entities) }, { async: false });
                        }
                    });
                }
            });
            //buttons.push({
            //    title: 'Export',
            //    cssClass: 'send-button',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {
                    
            //        var items = this.view.getItems();
            //        if (items.length == 0) {
            //            q.alert("Warning", "No data to export", true, 2999);
            //            return;
            //        }
            //        // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
            //        //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
            //        Q.postToService({
            //            service: ItemsRegisterService.baseUrl + '/OrderDetailSelectedExportExcel',
            //            request: {
            //                Items: items,
            //            },

            //            target: '_blank'
            //        });
            //    }
            //});
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,            
                service: ItemsRegisterService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "Item Register"
            }));
            buttons.push(Serenity.ColumnPickerDialog.createToolButton(this as any));
            return buttons;
        }
        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params;

            //var vouchertypeid = this.vouchertypeid;
            //var voucherno = request.EqualityFilter.VoucherNo;
            //var partyids = request.EqualityFilter.PartyId;
            //(this.view.params as ReportFiltersRequest).VoucherTypeId = vouchertypeid;
            //(this.view.params as ReportFiltersRequest).VoucherNo = voucherno;
            //(this.view.params as ReportFiltersRequest).PartyIds = partyids;
            //this.refresh();
            return true;
        }

        
    }
}